export default __webpack_public_path__ + "cb52c17da534011994f94b266bd63323.svg";